import { Button, Tooltip } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import React, { FC, useEffect, useState } from "react";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

//IMAGES
import EnglishIcon from "assets/images/students/englishIcon.svg";
import FrenchIcon from "assets/images/students/frenchIcon.svg";
import StartIcon from "assets/images/students/teacherStart.svg";
import TEACHER from "../../../../assets/images/teacher/teacher.svg";

//!STYLES
import { FLAGS, removeDuplicates, StatusCode } from "common/enums";
import { useDispatch, useSelector } from "react-redux";
import s from "../components/assets/card.module.css";

import * as appRoutes from "config/routes.config";

import { setIdTeacher, setSeeAvis, setUserConnect } from "store/auth/authSlice";
import { openPaiementDrawer } from "store/chat/mainSlice";
import { handleClearTopicStrings, handleClearTopicStringsLength } from "utils/formats";

import CertificationBadge from "components/certificationBadge";
import TeacherCalendarForOrganism from "screens/organisme/classDetails/calendarTeacher";
import IconCourse from "screens/student/searchTeacher/components/iconCourse";
import DrawerAdsCreneauSpecific from "screens/teacher/components/availabilitySpecific/drawer";
import { displayDrawerAdsSpecific } from "store/adventissements";
import {
  setChatReceiverId,
  setSelectUserChat,
  toggleAppChat
} from "store/AppChat/appChat";
import { useFindRoomMutation } from "store/services/chat";
import SelectClassroomModal from "./SelectClassroomModal";

interface CardAdsTeacher {
  teacher: any;
  PlanningIsVisble?: boolean;
  isInstaProf?: boolean;
  instaProfData?: any;
  infoTeacherAcceptedReservation?: any;
  currentProfAccepted?: any;
  setCurrentProfAccepted?: any;
  isBtnInstaProf: boolean;
  resetDrawerInstaProf?: () => void;
  handleStudentAcceptTeacher?: any;
  showDrawerSearchInstaProf: () => void;
  handleDisplayTeacher: (id: string) => void;
  onShowDrawerCalendarProf: () => void;
  handleOpenDrwerProfileTeacher: () => void;
  setIsBtnInstaProf: React.Dispatch<React.SetStateAction<boolean>>;
  teacherAdded?: boolean;
}

const CardAdsTeacher: FC<CardAdsTeacher> = ({
  teacher,
  PlanningIsVisble = true,
  isInstaProf,
  handleStudentAcceptTeacher,
  setCurrentProfAccepted,
  onShowDrawerCalendarProf,
  setIsBtnInstaProf,
  handleDisplayTeacher,
  handleOpenDrwerProfileTeacher,
  showDrawerSearchInstaProf,
  teacherAdded,
}) => {
  //!HOOKS
  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const [findRoom, { isSuccess }] = useFindRoomMutation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClassroom, setSelectedClassroom] = useState<any>(null);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);

  const closeDrawerPaiement = () => {
    dispatch(openPaiementDrawer());
  };

  const day = new Date();

  const handleDisplayTeacherMSG = (idTeacher: string) => {
    const finalData = {
      actor1: user?._id,
      actor2: idTeacher,
      flag: FLAGS.SINGLE_FLAG,
      type: "",
      instaprof: "",
    };

    findRoom(finalData);
    dispatch(setChatReceiverId(idTeacher));
  };

  ///Teachers
  const [isAdded, setIsAdded] = useState(teacherAdded ? true : false);
  const [loading, setLoading] = useState<boolean>(false);

  const setTeacher = async (idTeacher: string) => {
    setLoading(true);
    if (!isAdded) {
      try {
        const res = await AUTH_SERVICES.suggestTeacher(user?._id, idTeacher);
        if (res?.statusCode === StatusCode.CREATED) {
          setIsAdded(true);
        }
      }
      catch (error) { }
      finally {
        setLoading(false);
      }
    }
    else {
      try {
        const res = await AUTH_SERVICES.cancelSuggestTeacher(user?._id, idTeacher);
        if (res?.statusCode === StatusCode.CREATED) {
          setIsAdded(false);
        }
      }
      catch (error) { }
      finally {
        setLoading(false);
      }
    }
  }

  const handleProfileClick = () => {
    if (isLoggedIn) {
      dispatch(setIdTeacher(teacher?._id));
      const profileUrl = `${appRoutes.PROFILETEACHER}/${teacher?._id}/${teacher?.firstname ? teacher?.firstname : "nom"}.${teacher?.lastname ? teacher?.lastname : "complet"}`;
      window.open(profileUrl, "_blank");
    } else {
      dispatch(setUserConnect(true));
    }
  }

  const handleAddAvailability = () => {
    dispatch(displayDrawerAdsSpecific(true));
  };

  const handleSelectClassroom = (classroomId: string) => {
    setSelectedClassroom(classroomId);
    setShowDrawerCreProf(true);
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (!showDrawerCreProf) {
      setSelectedClassroom(null);
    }
  }, [showDrawerCreProf]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <>
      <div className={s.card}>
        <div className={s.avatarNameBox} onClick={handleProfileClick}>
          <div className={s.avatarBox}><img src={teacher?.profile || TEACHER} height={isMobile ? 40 : 70} style={{ borderRadius: "50%" }} /></div>
          <div className={s.nameRateBox}>
            <Tooltip
              title={
                <span style={{ textTransform: "capitalize" }}>
                  {teacher?.firstname + " " + teacher?.lastname ||
                    "-"}
                </span>
              }
            >
              <div className={s.nameBox}>
                {teacher?.firstname?.split(" ")[0] || "-"}{" "}
                {teacher?.lastname?.split(" ")[0] || "-"}
                {teacher?.certified && <CertificationBadge />}
              </div>
            </Tooltip>

            <span style={{ textTransform: "uppercase", lineHeight: isMobile ? "10px" : "14px" }}>
              {teacher?.points > 0 &&
                teacher?.points <= 1000 &&
                "C'est mon ami"}
              {teacher?.points > 1000 &&
                teacher?.points <= 5000 &&
                "C'est mon grand ami"}
              {teacher?.points > 5000 &&
                teacher?.points <= 10000 &&
                "C'est mon vieil ami"}
              {teacher?.points > 10000 && "Tu es mon meilleur ami"}
            </span>

            <div className={s.rate} style={{ lineHeight: isMobile ? "15px" : "20px" }} onClick={() => {
              dispatch(setSeeAvis(true));
              handleProfileClick();
            }}>
              <span className={s.rateNumber}>
                {teacher?.rate && teacher?.rate !== 0 && Number(teacher?.rate).toFixed(2)}
                {teacher?.rate && teacher?.rate !== 0 && <img src={StartIcon} style={{ position: "relative", top: "-2px", marginLeft: "5px", marginRight: "5px" }} />}
                {teacher?.rateNum && teacher?.rateNum !== 0 && `(${teacher?.rateNum || 0} avis)`}
              </span>
            </div>

            <div style={{ color: "#707070", lineHeight: "10px" }}>
              <>
                <span>
                  Je parle
                </span>{" "}
                {teacher?.langues?.includes("en") && (
                  <>
                    <img src={EnglishIcon} alt="" />{" "}
                  </>
                )}
                {teacher?.langues?.includes("fr") && (
                  <img src={FrenchIcon} alt="" />
                )}
              </>
            </div>
            <div style={{ color: "#707070", lineHeight: "10px" }}>
              {teacher?.fuseauHorraire && <div className="fuseauBoxOrga">
                <span>{teacher?.fuseauHorraire.split(" ")[1] + " " + teacher?.fuseauHorraire.split(" ")[2] + " " + teacher?.fuseauHorraire.split(" ")[3]}</span>
              </div>}
            </div>
          </div>
        </div>
        <div className={s.__description}>
          <Latex>
            {teacher?.career
              ? teacher?.career?.replace(/<\/?strong>/g, '').substring(0, 45)?.concat("...")
              : "Aucune description disponible"}
          </Latex>
        </div>
        <div className={s.matiers}>
          {handleClearTopicStrings(teacher?.matieres)?.slice(0, isMobile ? 3 : 6).map((item: string) =>
            item ? (
              <div className={s.course} key={item}>
                <IconCourse course={item} />
                <span>
                  {item.includes("-")
                    ? item.split("-")[0]
                    : item === "Anglais"
                      ? "Anglais"
                      : item === "Mathématiques"
                        ? "Maths"
                        : item}
                </span>
              </div>
            ) : null
          )} {isMobile && handleClearTopicStringsLength(teacher?.matieres) > 3 && "..."}
        </div>
        <div className={s.levelGroup}>
          {teacher?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
            {removeDuplicates(teacher?.groupLevels)?.slice(0, isMobile ? 3 : 6).map((level: any, index: number) => {
              return (
                level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                  <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                </div>
              );
            })} {isMobile && teacher?.groupLevels?.length > 3 && "..."}
          </div> : <span>Non renseigné</span>}
        </div>

        {/* <div className={s.tarif}>
          <span>Mes cours à partir de</span>{" "}
          {ad.minPrice}€/séance
        </div> */}

        <Button onClick={() => setShowDrawerCreProf(true)} className={s.newCalendarButton}>
          Voir le calendrier
        </Button>

        <div className={s.rowButtons}>
          <Button onClick={handleAddAvailability} className={s.newPlanningButton}>
            Ajouter un créneau
          </Button>

          <Button onClick={() => setIsModalOpen(true)} className={s.bookingButton}>
            Réserver un créneau
          </Button>
        </div>
      </div>

      {/* Drawer Creneau Specific */}
      {teacher && <DrawerAdsCreneauSpecific
        isCollective={true}
        className={""}
        classeId={""}
        teacher={teacher}
      />}

      <SelectClassroomModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        teacherId={teacher?._id}
        onSelect={handleSelectClassroom}
      />

      {selectedClassroom && (
        <TeacherCalendarForOrganism
          open={showDrawerCreProf}
          setOpen={setShowDrawerCreProf}
          currentTeacher={teacher}
          classroomId={selectedClassroom}
          onClose={() => { }}
        />
      )}

      <TeacherCalendarForOrganism
        open={showDrawerCreProf}
        setOpen={setShowDrawerCreProf}
        currentTeacher={teacher}
        onClose={() => { }}
      />

    </>
  );
};

export default CardAdsTeacher;
